import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/landing/Header";
import Footer from "../components/landing/Footer";
import SEO from "../components/SEO";

export default function NotFound() {
  return (
    <>
      <SEO title="Not found — Culmora OS" description="This page could not be found." path="/404" noindex />
      <Header />
      <main id="main" className="pt-24 pb-24">
        <div className="z-page text-center">
          <p className="uppercase text-xs tracking-[0.24em] text-[hsl(var(--z-teal))]">
            404
          </p>
          <h1 className="font-display mt-4 text-[clamp(48px,7vw,88px)] leading-[1.02]">
            This page isn’t here.
          </h1>
          <p className="mt-4 text-[hsl(var(--z-text-muted))] max-w-[50ch] mx-auto">
            The page you asked for could not be found. Return to the Culmora OS
            homepage or join early access to follow development.
          </p>
          <div className="mt-8 flex justify-center gap-3">
            <Link to="/" className="z-btn-primary" data-testid="nf-home">
              Back to home
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
